import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { newrotuneLogoFullBlack } from '../../../assets/logo';
import { useAuth } from '../../../lib/auth/AuthContext';

export const SplashScreen: React.FC = () => {
  const navigate = useNavigate();
  const { initialized, session } = useAuth();

  useEffect(() => {
    if (!initialized) return;
    const timeout = window.setTimeout(() => {
      navigate(session ? '/app/explore' : '/auth', { replace: true });
    }, 1200);
    return () => window.clearTimeout(timeout);
  }, [initialized, session, navigate]);

  return (
    <div className="flex min-h-svh w-full flex-1 flex-col items-center justify-center bg-background px-6">
      <img
        src={newrotuneLogoFullBlack}
        alt="Newrotune"
        className="mb-6 h-12 w-auto max-w-[min(90vw,280px)] object-contain sm:h-14"
      />
      <p className="mt-2 text-center text-xs text-textMuted">
        Gently retune your brain and body, one quiet moment at a time.
      </p>
    </div>
  );
};

